import React, { useEffect } from "react";
import QuizIntro from "../components/QuizIntro";
import Navbar from "../components/Navbar";
import { logEvent, logPageView } from "../utils/analytics";

const QuizIntroPage = () => {
  useEffect(() => {
    // Track quiz page view
    logPageView("/quiz1");
    logEvent("Quiz", "ViewContent", "Quiz Step 1");
  }, []);
  return (
    <div className="min-h-screen bg-[#EDE3DD] p-2 md:p-8">
      <Navbar navItems={[]} />
      <QuizIntro />
    </div>
  );
};

export default QuizIntroPage;
